import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Cookie, X } from 'lucide-react';

const KEY = 'firmpay_cookie_consent_v1';

export function CookieConsentBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const saved = localStorage.getItem(KEY);
      if (!saved) setVisible(true);
    } catch (_) { /* ignore */ }
  }, []);

  const accept = () => {
    try {
      localStorage.setItem(KEY, JSON.stringify({
        accepted: true,
        at: new Date().toISOString(),
      }));
    } catch (_) { /* ignore */ }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 inset-x-0 z-50 border-t border-slate-200 bg-white/95 backdrop-blur shadow-lg"
      role="dialog"
      aria-label="Consentimiento de cookies"
      data-testid="cookie-banner"
    >
      <div className="max-w-6xl mx-auto p-4 flex flex-col sm:flex-row items-start sm:items-center gap-3">
        <div className="flex items-start gap-3 flex-1">
          <div className="h-9 w-9 rounded-full bg-slate-900 text-white flex items-center justify-center shrink-0">
            <Cookie className="h-4 w-4" />
          </div>
          <div className="text-sm text-slate-700">
            Usamos <strong>almacenamiento local</strong> para mantener su sesión y preferencias.
            No usamos cookies de rastreo ni publicitarias. Vea nuestra{' '}
            <Link to="/legal/cookies" className="underline text-slate-900" data-testid="cookie-banner-policy-link">
              política de cookies
            </Link>.
          </div>
        </div>
        <div className="flex items-center gap-2 shrink-0 self-stretch sm:self-auto">
          <Button onClick={accept} data-testid="cookie-banner-accept">Entendido</Button>
          <Button variant="ghost" size="sm" onClick={() => setVisible(false)} aria-label="Cerrar" data-testid="cookie-banner-dismiss">
            <X className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </div>
  );
}
